import { render, staticRenderFns } from "./JournalFilters.vue?vue&type=template&id=c50e50f4&"
import script from "./JournalFilters.ts?vue&type=script&lang=ts&"
export * from "./JournalFilters.ts?vue&type=script&lang=ts&"
import style0 from "./JournalFilters.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports